module.exports = __webpack_public_path__ + "static/media/0026_LES_ENSEIGNES_LE_BOUCHER_SCRABBLE.8fc0bfc8.webp";